module.exports = __webpack_public_path__ + "static/media/DSC_0318.1adc9502.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0318.jpg
// module id = 594
// module chunks = 0